export enum ShowTypes {
    all = 'all',
    focus = 'focus',
    mouseover = 'mouseover'
}
